export const RoleStage = {
    DEFAULT: "D",
    READ: "R",
    WRITE: "W",
    CUSTOM: "C",
    NONE: "N"
};
